import { SET_PREFERRED_LOCATION_LISTS } from 'src/actions/preferredLocationListsActions';

const initialState = {
  preferredLocationLists: [],
};

// This is a Redux convention and requirement for reducers to work correctly
// eslint-disable-next-line default-param-last
const preferredLocationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PREFERRED_LOCATION_LISTS:
      return {
        ...state,
        preferredLocationLists: action.payload,
      };
    default:
      return state;
  }
};

export default preferredLocationListReducer;
